// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xtermButton {\n  width: 4rem;;\n}", "",{"version":3,"sources":["webpack://./../../libs/remix-ui/terminal/src/lib/components/remix-ui-terminal-menu-buttons.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".xtermButton {\n  width: 4rem;;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
